'use client'

import { useQuery } from '@tanstack/react-query'

import { getQueryClient,QueryKey } from 'shared/api'

import { getDeliveryAddresses } from '../api'
import { CustomerAddress } from '../types'

export function useQueryCustomerDeliveryAddresses(token: string) {
  return useQuery<CustomerAddress[]>({
    queryKey: [QueryKey.deliveryAddresses, token],
    queryFn: async ({ queryKey }) => {
      const response = await getDeliveryAddresses(queryKey[1] as string)
      
      return response.data.data
    },
    enabled: !!token,
    staleTime: 60000
  })
}

export const queryFetchDeliveryAddresses = async (token: string) => {
  return await getQueryClient().fetchQuery<CustomerAddress[]>({
    queryKey: [QueryKey.deliveryAddresses, token],
    queryFn: async () => {
      const response = await getDeliveryAddresses(token || '')

      return response.data.data
    }
  })
}
